import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";

const api = axios.create({
  baseURL: "https://buscaaqui.gruponix.com.br/api",
  timeout: 15000
});

/**
 * Request interceptor
 */
api.interceptors.request.use(
  function(config) {
    const token = Cookies.get("admin-logged");

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor
 * Trata sessão expirada (401)
 */
api.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.error("API error:", error);
    if (error && error.response && error.response.status === 401) {
      // evita loop se já estiver no login
      if (router.currentRoute.value.name !== "login") {
        Cookies.remove("admin-logged");
        Cookies.remove("user");

        router.replace({
          name: "login",
          query: { expired: "true" }
        });
      }
    }

    return Promise.reject(error);
  }
);

export default api;
